import { useTranslation } from '@frontend/i18n';
import { DropdownFilterChipField, useForm } from '@frontend/design-system';
import type { SourceDropdownFilterOptions } from '../../hooks/use-get-source-dropdown-filter-details';

type Props = {
  sourceOptions: SourceDropdownFilterOptions;
  onChange: (values: string[]) => void;
};

export const SourceDropdownFilterChip = ({ sourceOptions, onChange }: Props) => {
  const { t } = useTranslation('schedule');

  const { getFieldProps } = useForm({
    fields: {
      sources: { type: 'checklist', value: [] },
    },
  });

  return (
    <DropdownFilterChipField
      {...getFieldProps('sources')}
      name='sources'
      icon='data-sync'
      label={t('Source')}
      getCustomLabel={(items) => (items.length > 1 ? t('{{count}} Sources', { count: items.length }) : items[0])}
      showClearAll={false}
      onApply={({ value, close }) => {
        getFieldProps('sources').onChange(value as any);
        onChange(value);
        close();
      }}
    >
      {sourceOptions.map(({ label, value }) => (
        <DropdownFilterChipField.Option key={value} value={value}>
          {label}
        </DropdownFilterChipField.Option>
      ))}
    </DropdownFilterChipField>
  );
};
